
// Variáveis das cores
import colorsItens from "../variaveis-grafico";

//retorna o elemento HTML
function getGrafico(idElemento) {
    return document.getElementById(idElemento);
}

// Checa o total
function checkTotal(porcentagem) {
    var totalPorcentagem = 100 - porcentagem;
    if(totalPorcentagem > 0) {
        return true;
    }
    return false;
}

// Calcula a porcentagem
function calcPorcentagem(total, item) {
    return ((item * 100) / total);
}


// Set cor no gráfico
function setDataGrafico(grafico) {
    var data = [];
    var dados = $(grafico).find('.grafico');
    var total = $(grafico).find('.grafico-total').data('value');
    var index = 0;
    var porcentagem = 0;

    dados.each(function (i) {
       var elAtual = $(this);
       var valueNumberPorcento = calcPorcentagem(total, elAtual.data('value'))
       data.push({
        label: elAtual.data('label'),
        number: valueNumberPorcento,
        valorLabel: elAtual.data('value'),
        color: colorsItens[i],
        total: false,
       });
       index = i;
       porcentagem += valueNumberPorcento;
    });

    var totalCheck = checkTotal(porcentagem, grafico);

    if(totalCheck) {
        data.push({
            label: $(grafico).find('.grafico-total').data('label'),
            number: 100 - porcentagem,
            valorLabel: $(grafico).find('.grafico-total').data('value'),
            color: "#C7DCE9",
            total: true
        })
    }
    return data;
}


function drawLegend(data, legend) {
    legend.innerHTML += '<div class="legenda-item"><div class="cor" style="background-color:'+data.color+'"></div><div>'+data.label+'</div></div>'
}

function initLegend(grafico, data, legendFormat) {
    var legend = document.querySelectorAll('[data-legenda="'+$(grafico).attr('id')+'"]');
    var largura = $(grafico).find('.grafico-svg')[0].getBoundingClientRect().width;
    legend[0].style.width = largura+'px';
    if(legendFormat && typeof legendFormat === 'function') {
        return legendFormat(data);
    } else {

        for(var i = 0; i < data.length; i++) {
            drawLegend(data[i], legend[0]);
        }
    }
}

// Monta o gráfico utilizando a biblitoeca d3 e d3-tip
function drawPie(data, grafico, labelFunction, legendFormat) {
    var $container = $(grafico),
        width = $container.width(),
        height = width/2,
        r = width/2,
        ir = r/2,
        pi = Math.PI;

    var pie = d3.pie();
    pie.padAngle(.01)
        .sort(null)
        .value(function (d) {
            return d.number;
        })
        .startAngle(-90 * (pi / 180))
        .endAngle(90 * (pi / 180));
    var tip = d3.tip()
        .attr('class', 'd3-tip')
        .offset([-10, -10])
        if(labelFunction && typeof labelFunction === 'function') {
            tip.html(labelFunction);
        } else {
            tip.html(function (d) {
                return '<p class="label">' + d.data.label + '</p><p>' + d.data.valorLabel + '</p>';
            });
        }

    var arc = d3.arc().outerRadius(r - 40).innerRadius(ir - 5);

    var object = d3.select(grafico).append('object')
        .attr('width','100%')
        .attr('height','auto')
        .style('display', 'block')
        .style('position', 'relative')
        .style('padding-top', height+'px');

    var vis = object.append('svg')
        .data([data])
        .attr('width', '100%')
        .attr('height', '100%')
        .attr('viewBox','0 0 '+width +' '+height )
        .attr('preserveAspectRatio','xMinYMin')
        .style('position','absolute')
        .style('top','0')
        .style('left','0')
        .append('g')
        .attr('class', 'grafico-svg')
        .attr('transform', 'translate(' + r + ',' + r + ')');

    vis.call(tip);

    var arcs = vis.selectAll('g.slice')
        .data(pie)
        .enter()
        .append('g')
        .attr('class', function(d) {
            if(d.data.total) {
                return 'slice total-slice';
            } else {
                return 'slice';
            }
        });
        arcs.on('mouseover', function (d) {
            tip.show(d, this);
            $('.d3-tip').css('background-color', d.data.color);
            if(d.data.total) {
                $('.d3-tip').addClass('is-active total');
            } else {
                $('.d3-tip').addClass('is-active');
            }

        })
        .on('mouseout', function (d) {
            tip.hide(d, this);

            $('.d3-tip').removeClass('is-active total');
        });

    arcs.append('path')
        .attr('d', arc)
        .attr('fill', function(d,i) {
           return data[i].color;
        })
        .on('mouseover', function (d, i) {
            d3.select(this)
                .transition()
                .duration(500)
        })
        .on('mouseout', function (d, i) {
            d3.select(this)
                .transition()
                .duration(500)
                .attr('fill', data[i].color)
                .attr('d', arc);
        });

    // Inicializa a legenda
    initLegend(grafico, data, legendFormat);
}

// Inicializa o módulo
function init(idElemento, labelFunction = null, legendFormat = null) {
    var grafico = getGrafico (idElemento);
    var dataset = setDataGrafico(grafico);
    drawPie(dataset, grafico, labelFunction, legendFormat)
}

export default {
    init
}


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/semi-circulo.js